import React from "react";
import "./Footer.css";
import { Fade } from "react-reveal";
import { greeting } from "../../portfolio.js";
/* eslint-disable jsx-a11y/accessible-emoji */

export default function Footer(props) {
  return (
    <div className="footer-div">
      <Fade>
        <p className="footer-text" style={{ color: props.theme.text }}>
          Developed with <span class="heart"> ♥ </span>
           by&nbsp;
           <span title="Sushant Meera Surendra Prabhu: A Life Defined by Curiosity and Compassion
\n  
Obituary : Born on 12/03/1998. Sushant Prabhu, passed away at the age of [Age].
\n
Sushant, a beacon of wisdom and kindness, has left an indelible mark in the hearts of those who knew him. 
\n
His journey, marked by a relentless pursuit of knowledge and a deep commitment to helping others, was a testament to a life well-lived.
He connected effortlessly with people, offering guidance and support. 
His contributions to community and mentorship reflected his belief in the value of collaboration and compassion.
\n
Sushant's legacy is one of curiosity, kindness, and the joy of continuous learning.
His life should only remind you to embrace knowledge, cherish personal connections, and approach challenges with both wisdom and humor always.
\n

What consumes your mind controls your life.

"> 
       {greeting.sub} </span>
        </p>
        {/* <ToggleSwitch theme={props.theme} onToggle={props.onToggle}/> 
             <i class="fa fa-heart pulse"></i> 
             &emsp;<a href="https://www.linkedin.com/in/sushant-prabhu/">Template</a>
             &emsp;<a href="https://www.linkedin.com/in/sushant-prabhu/">Credits</a>
             */
        }
      </Fade>
    </div>
  );
}
